import Rest from '@/services/Rest';

/**
 * @typedef {EnviosService}
 */
export default class EnviosService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/envios'
}